import { createPlugin } from 'draft-extend'

const BLOCK_TYPE = 'unstyled'

export default createPlugin({
  blockToHTML: (block) => {
    if (block.type === BLOCK_TYPE) {
      return <div/>
    }
  },
})



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/Editor/plugins/paragraph/index.js